// src/components/RootProviders.js
import React from "react";
import { ThemeProvider } from "theme-ui";
import theme from "../gatsby-plugin-theme-ui";
import { NavigationProvider } from "../context/NavigationContext";
import { CountyProvider } from "../components/CountyContext";
import { DataProvider } from "../context/DataContext";
import { SeasonProvider } from "../context/SeasonContext";
import { AlertsProvider } from "../context/AlertsContext";
import { WeatherProvider } from "../components/WeatherContext";
import {
  ChecklistDefaultsProvider,
  useChecklistDefaults,
} from "../context/ChecklistDefaultsContext";
import GlobalHighlightStyles from "../styles/GlobalHighlightStyles";
import { useStaticQuery, graphql } from "gatsby";

// WeatherProvider that reads defaults from ChecklistDefaults
const WeatherWithDefaults = ({ children }) => {
  const { defaultHazard, defaultAlertType } = useChecklistDefaults();
  return (
    <WeatherProvider
      initialWeather={defaultHazard}
      initialAlertType={defaultAlertType}
    >
      {children}
    </WeatherProvider>
  );
};

const RootProviders = ({ children }) => {
  const data = useStaticQuery(graphql`
    query RootCountyMappingForAlerts {
      allNwsCountyCodesCsv {
        nodes {
          nws_county_code
          county
          center_lat
          center_long
        }
      }
    }
  `);

  const countyMapping = data.allNwsCountyCodesCsv.nodes;

  return (
    <NavigationProvider>
      <ThemeProvider theme={theme}>
        <GlobalHighlightStyles />
        <CountyProvider>
          <DataProvider shouldFetchData={true}>
            <SeasonProvider>
              <AlertsProvider countyMapping={countyMapping}>
                <ChecklistDefaultsProvider>
                  <WeatherWithDefaults>{children}</WeatherWithDefaults>
                </ChecklistDefaultsProvider>
              </AlertsProvider>
            </SeasonProvider>
          </DataProvider>
        </CountyProvider>
      </ThemeProvider>
    </NavigationProvider>
  );
};

export default RootProviders;
